var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-entity-info',{staticClass:"v-product-entity-info",attrs:{"imageUrl":_vm.entity.image}},[[_c('span',{attrs:{"data-cy":_vm.dataCy}},[_vm._v(_vm._s(_vm.entity.name))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }